// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1BXOn","errorLogs":"EditorFooter_errorLogs__11Cjs"};